import { Injectable } from '@angular/core';
import { HttpService } from '@core/services/http/http.service';
import { BranchViewModel } from '@shared/models/branch-view.model';
import { URLParamsService } from '@shared/services/url-params.service';
import { BranchNewViewModel } from '@shared/models/branch-new-view.model';
import { Paginator } from '@shared/models/paginator';
import { ModelList } from '../models/ModelList';
import { Observable } from 'rxjs';


@Injectable()
export class BranchService {
  static readonly url = 'Branch/';
  private cached: BranchViewModel[] = [];

  constructor(private httpService: HttpService) { }

  getAllBranches(): Observable<BranchViewModel[]> {
    const url = `${BranchService.url}GetAllBranches`;

    return this.httpService.GetRequest<BranchViewModel[]>(url);
  }

  get(paginator: Paginator): Observable<ModelList<BranchViewModel>> {
    const url = URLParamsService.buildUrl(`${BranchService.url}GetBranches`, {
      pageSize: paginator.pageSize,
      page: paginator.pageIndex + 1
    });

    return this.httpService.GetRequest<ModelList<BranchViewModel>>(url);
  }

  getById(id: number): Promise<BranchViewModel> {
    const url = URLParamsService.buildUrl(`${BranchService.url}GetBranch`, {
      id: id
    });

    return new Promise((resolve, reject) => {

      if (this.cached && this.cached.find(b => b.id === id)) {
        return resolve(this.cached.find(b => b.id === id));
      }

      this.httpService.GetRequest<BranchViewModel>(url).subscribe((data) => {
        this.cached.push(data);
        resolve(data);
      }, (error) => reject(error));
    });
  }

  save(branch: BranchNewViewModel): Observable<BranchViewModel> {
    const url = `${BranchService.url}SaveBranch`;

    if (branch.ID) {
      return this.update(branch);
    }

    return this.httpService.PostRequest<BranchViewModel, BranchNewViewModel>(url, branch);
  }

  update(branch: BranchNewViewModel): Observable<BranchViewModel> {
    const url = `${BranchService.url}UpdateBranch`;

    return this.httpService.PutRequest<BranchViewModel, BranchNewViewModel>(url, branch);
  }


  delete(id: number): Observable<any> {
    const url = URLParamsService.buildUrl(`${BranchService.url}DeleteBranch`, {
      ID: id
    });

    return this.httpService.DeleteRequest<BranchViewModel, null>(url, null);
  }
}
